module.exports = __webpack_public_path__ + "static/media/flag05.d164321f.svg";